import {
    faClose
} from '@fortawesome/pro-regular-svg-icons/faClose';
import {
    FontAwesomeIcon
} from '@fortawesome/react-fontawesome';
import {
    Box,
    Button,
    Modal as MUIModal
} from '@mui/material';
import {
    type FC,
    useRef
} from 'react';

import DialogNotifications from '@components/shared/DialogNotifications';

import useFocusRecovery from '@utils/useFocusRecovery';

import type {
    ModalProps
} from './types';

import styles from './styles';

const Modal: FC<ModalProps> = (props) => {
    const {
        children,
        handleClose,
        isVisible,
        title
    } = props;

    const contentRef = useRef<HTMLDivElement | null>(null);

    useFocusRecovery(contentRef, isVisible);

    return (
        <MUIModal
            onClose={handleClose}
            open={isVisible}
        >
            <Box
                aria-label={title}
                aria-modal
                role={'dialog'}
                sx={styles.wrapper}
            >
                <Box
                    ref={contentRef}
                    sx={styles.modal}
                    tabIndex={-1}
                >
                    <DialogNotifications />
                    {children}
                </Box>
                <Button
                    aria-label={'Close'}
                    onClick={handleClose}
                    sx={styles.close}
                    variant={'contained'}
                >
                    <FontAwesomeIcon
                        icon={faClose}
                        size={'2x'}
                    />
                </Button>
            </Box>
        </MUIModal>
    );
};

export default Modal;
